var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canChange)?_c('li',{staticClass:"list-inline-item"},[_c('a',{staticClass:"mhead-lang is-clickable",attrs:{"title":_vm.i18n.alternate.menuTooltip},on:{"click":_vm.changeLang}},[_vm._v(" "+_vm._s(_vm.i18n.current.menuName)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }